/**
 * @generated SignedSource<<1e507f6d846a5d8e296f511184860ee0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_DetailView$data = {
  readonly " $fragmentSpreads": FragmentRefs<"cardContainer_issueNavigator" | "main_issueNavigator_CardList_fragment" | "main_issueNavigator_IssueAppWithData">;
  readonly " $fragmentType": "main_issueNavigator_DetailView";
};
export type main_issueNavigator_DetailView$key = {
  readonly " $data"?: main_issueNavigator_DetailView$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_DetailView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_DetailView",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_CardList_fragment"
    },
    {
      "kind": "FragmentSpread",
      "name": "cardContainer_issueNavigator"
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_IssueAppWithData"
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "69dc512ab37afa44c5ab9377e45de769";

export default node;
